import { isTemplateExport } from "@circle-react-shared/BuilderUI/Helpers/typePredicates";
import {
  OtherBlock,
  TemplateBlock,
} from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import type { BlockExport } from "../../BuilderUI.types";
import type { BlockCategory } from "../../DataModel.types";

export const categoryIsPresent = (
  block: BlockExport,
  categoryToFind: BlockCategory,
): boolean => {
  if (isTemplateExport(block)) {
    return categoryToFind.name === TemplateBlock.name;
  }

  const blockCategories = block.meta.category ?? [];

  if (categoryToFind.name === OtherBlock.name && blockCategories.length === 0) {
    return true;
  }

  return blockCategories.some(
    category => category.name === categoryToFind.name,
  );
};
